import './index.scss';

import { ChangeEvent, Component, FocusEvent } from 'react';

import { BraxUncontrolledTextField, BraxUncontrolledTextFieldProps } from '../BraxUncontrolledTextField';
import { BraxIcon } from '../../BraxIcon';

export type BraxUncontrolledSearchFieldProps = Omit<BraxUncontrolledTextFieldProps, 'type' | 'mask'> & {
    onSearch?: (value: string | undefined) => void,
    searchDelay?: number | false
};

export class BraxUncontrolledSearchField extends Component<BraxUncontrolledSearchFieldProps> {

    static defaultProps = {
        disabled: false,
        status: null,
        searchDelay: 1500
    };

    state = {
        value: this.props.value
    };

    lastSearchValue = this.state.value;

    timeout?: number;

    componentWillUnmount() {
        this.clearTimeout();
    }

    clearTimeout() {
        if (this.timeout)
            window.clearTimeout(this.timeout);
    }

    change(value: string, event: ChangeEvent<HTMLInputElement>) {
        this.setState({ value });

        this.clearTimeout();

        if (this.props.searchDelay)
            this.timeout = window.setTimeout(() => this.search(), this.props.searchDelay);

        this.props.onChange?.(value, event);
    }

    blur(event: FocusEvent<HTMLInputElement>) {
        this.search();

        this.props.onBlur?.(event);
    }

    search() {
        this.clearTimeout();

        if (this.lastSearchValue !== this.state.value) {
            this.lastSearchValue = this.state.value;

            this.props.onSearch?.(this.state.value);
        }
    }

    render() {
        const { onSearch, onChange, onBlur, searchDelay, ...props } = this.props;

        return (
            <div className="brax-search-field">
                <BraxUncontrolledTextField
                    type="search"
                    onChange={(value, event) => this.change(value, event)}
                    onBlur={event => this.blur(event)}
                    {...props}
                />

                <BraxIcon icon="magnifier" onClick={() => this.search()} />
            </div>
        );
    }

}
